import { render, staticRenderFns } from "./IndexGraph.vue?vue&type=template&id=2d2239e0&scoped=true&lang=html&"
import script from "./IndexGraph.vue?vue&type=script&lang=js&"
export * from "./IndexGraph.vue?vue&type=script&lang=js&"
import style0 from "./IndexGraph.vue?vue&type=style&index=0&id=2d2239e0&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2239e0",
  null
  
)

export default component.exports